var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{staticStyle:{"width":"24px","height":"24px"},attrs:{"viewBox":"0 0 24 24"}},[_c('path',{attrs:{"fill":"currentColor","d":"M13 14H11V9H13M13 18H11V16H13M1 21H23L12 2L1 21Z"}})])}
var staticRenderFns = []

export { render, staticRenderFns }